document.addEventListener('DOMContentLoaded', function () {
  const firstNameInput = document.querySelector('#ContactFooter .newsletter-name__input');
  const emailInput = document.querySelector('#ContactFooter .newsletter-email__input');
  const nameErrorElement = document.querySelector('.error');
  const emailErrorElement = document.querySelector('.email-error');
  const newsLettersubmitButton = document.getElementById('Subscribe');

  // Validate the first name input
  function validateFirstName() {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (firstNameInput.value.trim() === '') {
      nameErrorElement.textContent = "Anna etunimesi.";
      nameErrorElement.classList.remove('hidden');
      newsLettersubmitButton.classList.add('disabled');
      return false;
    } else if (!nameRegex.test(firstNameInput.value.trim())) {
      nameErrorElement.textContent = 'Vain kirjaimet ja välilyönnit ovat sallittuja.';
      nameErrorElement.classList.remove('hidden');
      return false;
    } else {
      nameErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Validate the email input
  function validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    if (emailInput.value.trim() === '') {
      emailErrorElement.textContent = "Anna sähköpostiosoitteesi.";
      emailErrorElement.classList.remove('hidden');
      return false;
    } else if (!emailRegex.test(emailInput.value.trim())) {
      emailErrorElement.textContent = 'Anna kelvollinen sähköpostiosoite.';
      emailErrorElement.classList.remove('hidden');
      return false;
    } else {
      emailErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Check overall form validity and enable/disable submit button
  function updateButtonState() {
    const isFormValid = validateFirstName() && validateEmail();
    if (isFormValid) {
      newsLettersubmitButton.disabled = false; 
      newsLettersubmitButton.classList.remove('disabled');
    } else {
      newsLettersubmitButton.disabled = true;
      newsLettersubmitButton.classList.add('disabled');
    }
  }

  // Input event listeners for immediate validation
  firstNameInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    validateFirstName(); 
    updateButtonState();
  });

  emailInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    validateEmail();
    updateButtonState(); 
  });

  newsLettersubmitButton?.addEventListener('click', (event) => {
  const isFirstNameValid = validateFirstName();
  const isEmailValid = validateEmail();
  if (!isFirstNameValid || !isEmailValid) {
    event.preventDefault();
    updateButtonState();
    return;
  }
});
});